import React from 'react';
import Header from './Header';
import Hero from './Hero';
import CareAreas from './CareAreas';
import PathToHealing from './PathToHealing';
import PatientStories from './PatientStories';
import SecondOpinion from './SecondOpinion';
import Award from './Award';
import Locations from './Locations';
import CareYouNeed from './CareYouNeed';
import Footer from './Footer';
import Testimonials from './Testimonials';
import FundingStreams from './FundingStreams';
import TeamPreview from './TeamPreview';

const HomePage = () => (
  <div className="App bg-white">
    <Header />
    <main>
      <Hero />
      <CareAreas />
      <PathToHealing />
      <PatientStories />
      <SecondOpinion />
      <Award />
      <TeamPreview />
      <Testimonials />
      <FundingStreams />
      <Locations />
      <CareYouNeed />
    </main>
    <Footer />
  </div>
);

export default HomePage;
